import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { Grid } from "@mantine/core";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import PieChart from "./chartWidget/PieChart";
import BarChart from "./chartWidget/BarChart";
import _ from "lodash";
import OrderStatsTable from "./orderStatsTable";

const OrderStatics = ({
  userId,
  numQuarters = 8,
  height = "100vh",
  InScrollArea = true,
  remark = null,
  hideTable = false,
  period: controlledPeriod,
  dateType: controlledDateType,
  onPeriodChange,
  onDateTypeChange,
}) => {
  const [orderStats, setOrderStats] = useState();

  const [internalPeriod, setInternalPeriod] = useState(null);
  const [internalDateType, setInternalDateType] = useState("signedDate");
  const [productTypePieData, setproductTypePieData] = useState([]);
  const [productCategoryPieData, setproductCategoryPieData] = useState([]);
  const [productProviderPieData, setproductProviderPieData] = useState([]);
  const [api] = useServerApi();

  const period = controlledPeriod ?? internalPeriod;
  const dateType = controlledDateType ?? internalDateType;

  const fetchStats = async () => {
    if (!userId) return;
    if (!period || !period.startDate || !period.endDate) return;

    const data = await api.Order.getStats(period, userId, dateType);

    if (!data) return;
    setOrderStats(data.orderSummary ?? []);
    setOrderProductStats(data);
  };

  const resetStatData = () => {
    setproductTypePieData([]);
    setproductProviderPieData([]);
    setproductCategoryPieData([]);
  };

  const setOrderProductStats = (data) => {
    try {
      if (!data || _.isEmpty(data.orderProductStats)) return resetStatData();

      _.isEmpty(data.orderProductStats.productType)
        ? setproductTypePieData([])
        : setproductTypePieData(
            data.orderProductStats.productType.map((c) => ({
              id: c.name,
              value: c.count,
            }))
          );

      setproductProviderPieData(
        data.orderProductStats.productProvider?.map((c) => ({
          id: c.shortName ?? c.code,
          value: c.count,
        })) ?? []
      );

      setproductCategoryPieData(
        data.orderProductStats.productCategory?.map((c) => ({
          id: c.name ?? c.code,
          value: c.count,
        })) ?? []
      );
    } catch (error) {
      console.log(error);
    }
  };

  useDeepCompareEffect(() => {
    fetchStats();
  }, [userId, period, dateType]);

  const handlePeriodChange = (p) => {
    if (onPeriodChange) onPeriodChange(p);
    else setInternalPeriod(p);
  };

  const handleDateTypeChange = (t) => {
    if (onDateTypeChange) onDateTypeChange(t);
    else setInternalDateType(t);
  };

  return (
    <>
      {!hideTable && (
        <OrderStatsTable
          data={orderStats}
          mt="50px"
          highlightOnHover
          withTableBorder
          showIndividualConsultant={true}
          remark={remark}
          onPeriodRefresh={() => fetchStats()}
          onPeriodChange={handlePeriodChange}
          onDateTypeChange={handleDateTypeChange}
          numPeriods={numQuarters}
        />
      )}
      <Grid mt="xl">
        <Grid.Col span={6}>
          <PieChart
            title={"Product Category"}
            staticData={productCategoryPieData}
            height={350}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <PieChart
            title={"Insurer"}
            staticData={productProviderPieData}
            height={350}
          />
        </Grid.Col>
      </Grid>
      <BarChart
        title="Product Types"
        height={350}
        description={"The number of order based on order types within quaters."}
        data={productTypePieData}
        chartProps={{
          keys: ["value"],
          layout: "horizontal",
          indexBy: "id",
        }}
      />
    </>
  );
};

export default OrderStatics;
